import React from 'react'
import Modal from '@material-ui/core/Modal'
import {makeStyles} from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import './IcalURL.scss'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3, 6, 2.5),
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 'normal',
    width: '564px',
    minHeight: '240px',
  },
  heading: {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  bodyText: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#596175',
    margin: '20px 0px',
  },
  inputBox: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#596175',
    width: '100%',
    background: '#FFFFFF',
    border: '1px solid #ACB0BA',
    boxSizing: 'border-box',
    borderRadius: 4,
    padding: '0 16px',
    height: 40,
  },
  copyButton: {
    background: '#3473FF',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 16px',
    color: '#FFFFFF',
    marginRight: '24px',
    fontSize: 16,
    fontWeight: 700,
    border: 'none',
    height: 32,
  },
  cancleButton: {
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 'bold',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 16px',
    color: '#303A52',
    fontSize: '16px',
    lineHeight: '24px',
    borderStyle: 'none',
    backgroundColor: '#FFFFFF',
  },
}))

export default function IcalPopup({open, handleClose, user, id}) {
  const [calURL, updateCalURL] = React.useState('')
  const [copySuccess, setCopySuccess] = React.useState('')
  const classes = useStyles()
  const inputRef = React.useRef(null)

  React.useEffect(() => {
    const currentPath = localStorage.getItem('parent_origin')
    const staticKey = 'integrations/calendar'

    const user_id = user?.details?.id
    const updatedURL = `${currentPath}/${staticKey}/${user_id}/${id}`
    if (updatedURL) {
      updateCalURL(updatedURL)
    }
    // eslint-disable-next-line
  }, [])

  const copyLink = e => {
    inputRef.current.select()
    document.execCommand('copy')
    e.target.focus()
    setCopySuccess('Copied!')
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={`${classes.modal} link-popup`}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <div>
            <p className={classes.heading}>Shareable link to your calendar</p>
          </div>
          <div>
            <p className={classes.bodyText}>
              Add this link to your external calendar, like Outlook or Google, to view your Asset
              Panda events.
            </p>
            <input ref={inputRef} className={classes.inputBox} defaultValue={calURL} readOnly />
          </div>
          <div className="d-flex justify-content-end ical-buttons mt-20">
            <button className={`${classes.copyButton} hover-effect`} onClick={e => copyLink(e)}>
              {copySuccess ? copySuccess : `Copy link`}{' '}
            </button>
            <button className={`cancel-btn ${classes.cancleButton}`} onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </Fade>
    </Modal>
  )
}
